import { useQuery } from '@tanstack/react-query'
import cacheKeys from '../../../../services/cacheKeys'
import { getProfile } from '../index'

const useGetProfile = () => {
  return useQuery({
    queryKey: [cacheKeys.GET_PROFILE],
    queryFn: getProfile,
  })
}

export default useGetProfile
